import { render, staticRenderFns } from "./motivo_remi.vue?vue&type=template&id=84ba2abc"
import script from "./motivo_remi.vue?vue&type=script&lang=js"
export * from "./motivo_remi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports